<template>
  <b-dropdown
    aria-role="list"
    class="compressedAnalysisDropdown margin-none padding-top12"
  >
    <button slot="trigger" slot-scope="{ active }">
      <span>{{ getCompressedAnalysisDropdownText }}</span>
      <b-icon :icon="active ? 'chevron-up' : 'chevron-down'"></b-icon>
    </button>
    <b-dropdown-item
      aria-role="listitem"
      v-for="(
        compressedAnalysis, compressedAnalysisIndex
      ) in dirtyCompressedAnalysis"
      :key="compressedAnalysis.id"
      :value="compressedAnalysis.title"
      @click="updateVisibleAnalysisHeader(compressedAnalysisIndex)"
    >
      <b-tooltip
        :active="compressedAnalysis.title.length > 13"
        :label="getUpperCase(compressedAnalysis.title)"
      >
        {{ getCompressedAnalysisTitle(compressedAnalysis.title) }}
      </b-tooltip>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { GripAnalysis } from '../../../store/types/grip.types';

@Component({})
export default class GripAnalysisCompressedNavigationTabs extends Vue {
  @Prop() public compressedAnalysis!: GripAnalysis[];
  public dirtyCompressedAnalysis: GripAnalysis[] = [];

  public mounted(): void {
    this.dirtyCompressedAnalysis = JSON.parse(
      JSON.stringify(this.compressedAnalysis),
    );
  }

  public updateVisibleAnalysisHeader(compressedAnalysisIndex: number): void {
    this.$emit('updateVisibleAnalysisHeader', compressedAnalysisIndex);
  }

  public getUpperCase(value: string): string {
    return value.toUpperCase();
  }

  public getCompressedAnalysisTitle(compressedAnalysisTitle: string): string {
    if (compressedAnalysisTitle.length > 13) {
      return `${compressedAnalysisTitle.substring(0, 11)} ...`.toUpperCase();
    }
    return compressedAnalysisTitle.toUpperCase();
  }

  get getCompressedAnalysisDropdownText(): string {
    return `${this.dirtyCompressedAnalysis.length} MORE...`;
  }
}
</script>

<style lang="scss" module></style>
